import { Star } from "lucide-react";

export const Stars = ({ value = 5, size = 14 }) => (
  <span className="inline-flex items-center gap-0.5" aria-label={`${value} sur 5 étoiles`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        className={i <= Math.round(value) ? "fill-sky-400 text-sky-400" : "text-slate-600"}
      />
    ))}
  </span>
);
